import { Component, Vue } from 'vue-property-decorator'

@Component
export default class goodsList extends Vue {
    // 商品列表的显示模式
    showMode = 'grid'
    // 商品列表
    goodsList = []
    // 获取商品列表时传入的参数
    params: any = {
        keywords: '',
        listIds: '',
        categoryOneIds: '',
        categoryTowIds: '',
        brandIds: '',
        minPrice: '',
        maxPrice: '',
        tagValues:'',
        sortSales: '',
        sortPrice: '',
        sortTime: ''
    }
    newKeywords: any = ''//重新搜素新关键词
    // 筛选方法
    filterList = [
        { type: "categoryOneIds", title: "一级分类", list: [] },
        { type: "categoryTowIds", title: "二级分类", list: [] },
        { type: "brandIds", title: "品牌", list: [], isSelectMore: true }
    ]
    sortFilters = [
        { label: '邮金币', value: "7700" }, { label: '促销活动', value: '8100' },
            { label: '套餐商品', value: '4040' }, { label: '邮账期', value: '1660' }
    ]
    // 分页信息
    page = { total: 0, pageSize: 20, pageNum: 1 }
    apis = window.apis
    filterCkecked:any = {
        categoryOneIds: "",
        categoryTowIds: ""
    }

    created() {
        this.params.keywords = this.$route.query.keywords || ''

        let oneIds = this.$route.query.categoryOneIds
        let towIds = this.$route.query.categoryTowIds
        if(oneIds){
            this.params.categoryOneIds = oneIds
            this.filterCkecked.categoryOneIds = oneIds
        }
        
        if(towIds){
            this.params.categoryTowIds = towIds
            this.filterCkecked.categoryTowIds = towIds
        }
        this.getList()
        this.getCategory()
        this.getCategoryTwo()
        this.getBrands()
        
    }
    search(){//重新搜索
        this.params.keywords = this.newKeywords;
        this.getList();
    }
    // 筛选
    filterChange(data: any, lvl: number) {
        console.log(data)
        data.forEach((ele: any) => {
            if (ele.ids) {
                this.params[ele.type] = ele.ids
            } else {
                this.params[ele.type] = ""
            }
        })

        if (lvl < 1) {
            this.getCategoryTwo()
        }

        if (lvl < 2) {
            this.getBrands()
        }

        this.getList()
    }
    /*
    ** fieldName: 排序字段
    ** type: 排序字段的值
    ** beginPrice: 起始价格
    ** endPrice：结束价格
    ** tags：优惠信息标签
    */
    sortLineChange(fieldName: string, type: string, beginPrice: string, endPrice: string, tags: any) {
        // 排序
        // 初始化为空
        this.params.sortSales = ''
        this.params.sortPrice = ''
        this.params.sortTime = ''

        // 最新的按时间倒叙排列
        if (fieldName && fieldName === 'sortTime') {
            this.params.sortTime = 'desc'
        } else {
            this.params[fieldName] = type
        }

        // 价格
        this.params.minPrice = beginPrice || ''
        this.params.maxPrice = endPrice || ''

        // 优惠活动

        if (tags) {
            // 活动标签赋值值
            this.params.tagValues = tags.join(',')
        }

        this.getList()
    }
    // 切换显示方式
    switchMode(mode: string) {
        this.showMode = mode
    }
    // 获取一级分类列表
    getCategory() {
        this.fetch({
            url: this.apis.categorys
        }).then((data: any) => {
            let tmpOne: any = []
            if(data && data.length > 0){
                data.forEach((c: any, i: number) => {
                    if (!c.id || c.id == '0') {
                        return false
                    }
                    let obj = tmpOne.filter((it: any) => it.id == c.id)
                    if (obj.length == 0)
                        tmpOne.push({ id: c.id, name: c.name, index: i })
                })
            }
            this.filterList[0].list = tmpOne
        })
    }
    // 获取二级分类列表
    getCategoryTwo() {
        let sendData = {
            categoryOneIds: this.params.categoryOneIds
        }
        this.fetch({
            url: this.apis.categoryIdLevel2,
            data: sendData
        }).then((data: any) => {
            let tmpTwo: any = []
            if(data && data.length > 0){
                data.forEach((c: any, i: number) => {
                    if (!c.id || c.id == '0') {
                        return false
                    }
                    tmpTwo.push({ id: c.id, name: c.name, index: i })
                })
            }
            this.filterList[1].list = tmpTwo
        })
    }
    // 品牌列表
    getBrands() {
        let sendData = {
            categoryOneIds: this.params.categoryOneIds,
            categoryTwoIds: this.params.categoryTowIds
        }
        this.fetch({
            url: this.apis.brand,
            data: sendData
        }).then((data: any) => {
            let brands:any = []
            if(data && data.length > 0){
                data.forEach((c: any, i: number) => {
                    if (!c.id || !c.name) {
                        return false
                    }
                    brands.push({ id: c.id, name: c.name, index: i })
                })
            }
            this.filterList[2].list = brands
        })
    }
    getList() {
        var params = {
            pageSize: this.page.pageSize,
            pageNum: this.page.pageNum,
            resultType: 'list',
            ...this.params
        }
        console.log(params)
        if(params.categoryOneIds != "" || params.categoryTowIds != ""){ // 如果存在分类搜索条件，清空关键字搜索条件
            params.keywords = ''
        }
        this.fetch({
            url: this.apis.goodsList,
            data: params
        }).then((data: any) => {
            console.log(data)
            this.page.total = data.total
            //整理列表数据 初始化taginfo
            data.list.forEach((item: any) => {
                item.tagInfo = item.tagInfo?item.tagInfo:{}
                // 初始化起订量
                item.goodsNum = item.beginNum = item.tagInfo.beginNum ? item.tagInfo.beginNum: 1;
                // 初始化限购数量
                item.limitNum = item.tagInfo.limitNum ? item.tagInfo.limitNum : 999999; 
              })
            //保存用户点击搜索内容
            if (this.params.keywords != '') {
                this.fetch({
                    url: this.apis.saveUserSearch,
                    data: {
                        name: this.params.keywords,
                        searchResult: data.length ? true : false
                    }
                })
            }
            this.goodsList = data.list;
            // this.$store.dispatch('goods/formatter',data.list).then((data:any)=>{
            //     this.goodsList = data;
            //     //保存用户点击搜索内容
            //     if (this.params.keywords != '') {
            //         this.fetch({
            //             url: this.apis.saveUserSearch,
            //             data: {
            //                 name: this.params.keywords,
            //                 searchResult: data.length ? true : false
            //             }
            //         })
            //     }
            // })
        })
    }

    // 选中第几页
    currentChange(page: number) {
        this.page.pageNum = page
        this.getList()
    }

    // 跳转商品详情
    goDetai(listId: number) {
        let url=this.$router.resolve({
            path:`/vi/${listId}`
        });
        window.open(url.href,'_blank')
    }

    // 进入购物车
    goCart() {
        this.$router.push("/cart")
    }
}
